const Map = () => {
    return (
        <div className="h-screen w-screen">
            <div class="mapouter w-screen h-screen">
                <div class="gmap_canvas w-screen h-screen overflow-hidden">
                    <iframe
                        className="h-screen w-screen overflow-hidden"
                        id="gmap_canvas"
                        src="https://maps.google.com/maps?q=crown%20of%20glory%20assembly&t=&z=13&ie=UTF8&iwloc=&output=embed"
                        frameBorder="0" scrolling="yes"
                        marginHeight="0" marginWidth="0">
                    </iframe>
                    <a href="https://123movies-to.org"></a>
                    <br />

                    <a href="https://www.embedgooglemap.net">embedgooglemap.net</a></div></div>
        </div>
    )
}

export default Map